<template>
  <span class="font-weight-bold" v-if="minutesLeft < 60">
    &nbsp;
    <span v-if="minutesLeft > 1"> ({{ minutesLeft }} min)</span>
    <span v-else> (NOW)</span>
  </span>
</template>

<script>
export default {
  props: {
    timeZone: {
      type: String,
      required: true,
    },
    departure_time: {
      type: String,
      required: true, // Format: 'HH:mm:ss'
    },
  },
  data() {
    return {
      minutesLeft: 0,
      intervalTimer: null,
    };
  },
  created() {
    this.calculateTimeDifference();
    this.intervalTimer = setInterval(this.calculateTimeDifference, 5000); // Update every 5 seconds
  },
  destroyed() {
    clearInterval(this.intervalTimer);
  },
  methods: {
    calculateTimeDifference() {
      // Get the current time in the specified timezone
      const now = new Date(
        new Date().toLocaleString("en-US", { timeZone: this.timeZone })
      );

      // Parse the departure time
      const [hours, minutes, seconds] = this.departure_time
        .split(":")
        .map(Number);

      // Create a new departure date for today
      let departureDate = new Date(now);
      departureDate.setHours(hours, minutes, seconds, 0);

      // If the departure time has already passed today, set it for tomorrow
      if (departureDate < now) {
        departureDate.setDate(departureDate.getDate() + 1);
      }

      // Calculate the time difference in milliseconds
      const timeDifferenceInMs = departureDate - now;

      // Convert milliseconds to minutes and round up
      const differenceInMinutes = Math.ceil(timeDifferenceInMs / (1000 * 60));

      // Update the minutesLeft
      this.minutesLeft = differenceInMinutes;
    },
  },
};
</script>

<style scoped>
html,
body,
.v-application {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

.v-container {
  height: 100vh;
}
</style>
